import { useNavigate } from "react-router-dom";

export const useMaintenance = ( ): {

    checkHealth( ): Promise<void>

} => {
    
    const navigate = useNavigate( );

    
    const checkHealth = async ( ): Promise<void> => {


        const query = `${process.env.REACT_APP_API_URL}/health/isAlive`;
        
        try{
            
            await fetch( query  );

        } catch {

            navigate( '/maintenance' );

        };
        
    };

    return { 
        
        checkHealth

    };

};